export const enum ETransportPages {
  LOAD_OVERVIEW = 'LOAD_OVERVIEW',
  TRANSPORT_MANAGEMENT = 'TRANSPORT_MANAGEMENT',
  UNLINKED_ORDERS = 'UNLINKED_ORDERS'
}
